import styled from "styled-components";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/section/footer/Footer";
import FounderHistory from "./components/FounderHistory";
import PartnershipSection from "./components/PartnershipSection";
import QuoteSection from "./components/QuoteSection";
import StorySection from "./components/StorySection";

const Wrapper = styled.div`
  width: 100%;
`;

const Container = styled.div``;

function FoundersPage() {
  return (
    <Wrapper>
      <Navbar />
      <Container>
        <StorySection />
        {/* <PostCardSection /> */}
        <FounderHistory />
        <QuoteSection />
        <PartnershipSection />
      </Container>
      <Footer />
    </Wrapper>
  );
}

export default FoundersPage;
